var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"viewer",staticClass:"viewer"}),_vm._v(" "),(_vm.spinner)?_c('div',{staticClass:"spinner"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }